import { render, staticRenderFns } from "./DisableCustomLinkModal.vue?vue&type=template&id=3b4e48fb&"
import script from "./DisableCustomLinkModal.vue?vue&type=script&lang=js&"
export * from "./DisableCustomLinkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports